import { render, staticRenderFns } from "./BulkAddTasksConfirmationModal.vue?vue&type=template&id=87e56858&scoped=true&"
import script from "./BulkAddTasksConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./BulkAddTasksConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./BulkAddTasksConfirmationModal.vue?vue&type=style&index=0&id=87e56858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e56858",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VSpacer})
